import React from 'react';

interface Props {
  children: React.ReactNode;
  className: string;
  eleRef?: React.Ref<HTMLDivElement>;
  size?: number | string;
  split?: 'horizontal' | 'vertical';
  style?: React.CSSProperties;
}

class Pane extends React.PureComponent<Props> {
  render() {
    const {children, className, split, style: styleProps, size, eleRef} = this.props;

    const classes = ['Pane', split, className];

    let style: React.CSSProperties = {
      flex: 1,
      position: 'relative',
      outline: 'none'
    };

    if (size !== undefined) {
      if (split === 'vertical') {
        style.width = size;
      } else {
        style.height = size;
        style.display = 'flex';
      }
      style.flex = 'none';
    }

    style = {
      ...style,
      ...styleProps
    };

    return (
      <div ref={eleRef} className={classes.join(' ')} style={style}>
        {children}
      </div>
    );
  }
}

export default Pane;
